export default "__VITE_ASSET__sRtK4Kul__"